export default __webpack_public_path__ + "static/media/ic_material.229f5b78.svg";